export const DELIVERY_DATA_LOADING = 'DELIVERY_DATA_LOADING';
export const DELIVERY_DATA_SUCCESS = 'DELIVERY_DATA_SUCCESS';
export const DELIVERY_DATA_FAILED = 'DELIVERY_DATA_FAILED';
export const DELIVERY_VIEW = 'DELIVERY_VIEW';
